import React from 'react';
import { Overlays } from '../overlays';
import MatchCard from '../matchCard';
import { UPCOMING_MATCHES_STATUS } from 'utils/constants';

const OverlayUpcomingMatches = ({ closeOverlay, matchesData }) => {
  const upcomingMatches =
    matchesData?.filter((match) => match.event_status_id === UPCOMING_MATCHES_STATUS) || [];

  return (
    <Overlays
      overlayName='genric'
      overlayConfig={{
        noOverlayHead: true,
        noOverlayFoot: false,
        noOverlayClose: true,
        submitBtn: false,
        title: 'UPCOMING MATCHES',
        titleTransKey: 'overlay_title_upcoming_matches',
        onClickProp: closeOverlay
      }}
    >
      <div className='si-popup__content'>
        <div className='si__matchCardList si__matchCardList--upcomingMatches'>
          <MatchCard matchesData={upcomingMatches} hideTimer={true} />
        </div>
      </div>
    </Overlays>
  );
};

export default OverlayUpcomingMatches;
